import React from 'react';
import PropTypes from 'prop-types';

import NewsletterBlog from '../NewsletterBlog/index.jsx';
import LoadMore from '../LoadMore/index.jsx';
import Spinner from '../Spinner/index.jsx';


class ArticleList extends React.Component {
  handleArticleUpdate(article, type, data) {
    if (this.props.onArticleUpdate) {
      this.props.onArticleUpdate(article, type, data);
    }
  }

  render() {
    var result = null;

    if ((! this.props.articles.length) && this.props.fetching) {
      result = (
        <div className="my-4">
          <Spinner />
        </div>
      );
    } else {
      var innerContent = [];

      if (this.props.articles.length) {
        for (var i = 0; i < this.props.articles.length; i++) {
          var article = this.props.articles[i];

          innerContent.push(
            <div key={article.id} className="cs-research-report-articles__item">
              <NewsletterBlog article={article} onUpdate={this.handleArticleUpdate}/>
            </div>
          );
        }
      } else {
        innerContent.push(
          <div key="empty" className="cs-research-report-articles__empty"></div>
        );
      }

      result = (
        <div className="cs-research-report-articles">
          {innerContent}
        </div>
      );
    }


    return result;
  }
}

ArticleList.propTypes = {
  fetching: PropTypes.bool,
  articles: PropTypes.array,
  onArticleUpdate: PropTypes.func
};

ArticleList.defaultProps = {
  fetching: false,
  articles: []
};


class NewsletterBlogsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      page: 1,
      fetching: false,
      articles: [],
      error: undefined,
      query: '',
      hasData: false,
      canPage: true
    };

    this.fetchComplete = this.fetchComplete.bind(this);
    this.fetchError = this.fetchError.bind(this);
    this.fetchPage = this.fetchPage.bind(this);
    this.handleArticleUpdate = this.handleArticleUpdate.bind(this);
    this.nextPage = this.nextPage.bind(this);
  }

  /**
   * retrieve the first 'page' of articles.
   */
  componentDidMount() {
    this.setState({ ready: true }, this.fetchPage);
  }


  fetchPage() {
    var filters;

    if (! this.state.fetching) {
      this.setState({ fetching: true, canPage: true });

      if (this.props.newsletterBlogCategories) {
        filters = [];
        for (var i = 0; i < this.props.newsletterBlogCategories.length; i++) {
          filters.push({ id: this.props.newsletterBlogCategories[i], value: true });
        }

      } else {
        filters = this.state.filters;
      }

      this.props.newsletterBlogsService.fetchPage(this.state.page, filters)
        .then(this.fetchComplete)
        .catch(this.fetchError);
    }
  }

  fetchComplete(response) {
    this.setState(function(oldState) {
      const articlesToAdd = response?.articles || response;
      const newArticles = oldState.articles.concat(articlesToAdd);
      const totalArticlesCount = response?.count || 0;

      return {
        articles: newArticles,
        canPage: articlesToAdd.length > 0,
        hasData: totalArticlesCount === 0 ? true : newArticles.length < totalArticlesCount,
        page: (oldState.page + 1),
        fetching: false
      };
    });
  }

  fetchError(error) {
    this.setState({ error: error, fetching: false });
  }

  nextPage() {
    if ((! this.state.fetching) && this.state.canPage) {
      this.fetchPage()
    }
  }

  handleArticleUpdate(article, type, data) {
    switch(type) {
      case 'reaction':
        this.setState({
          articles: this.state.articles.map(item => {
            if (item.id === article.id)
              return {...item, reactions: data.value}
            else
              return item;
          })
        })
      break;
    }
  }

  render() {
    var filters = null;
    var loadMore = null;
    var articles = null;

    if (this.state.ready) {

      articles = (
        <ArticleList
          fetching={this.state.fetching}
          articles={this.state.articles}
          onArticleUpdate={this.handleArticleUpdate}
        />
      );

      // display the load more button, but only once we've retrieved at least a
      // single page of articles.
      if (this.state.articles.length) {
        if (this.state.canPage) {
          if (this.state.hasData) {
            loadMore = (
              <LoadMore
                onClick={this.nextPage}
                fetching={this.state.fetching}
              />
            );
          }
        }
      }
    } else {
      filters = (
        <div className="my-4">
          <Spinner />
        </div>
      );
    }

    return (
      <React.Fragment>
        {filters}
        {articles}
        {loadMore}
      </React.Fragment>
    );
  }
}

export default NewsletterBlogsList;

